import { render } from "./GIS.vue?vue&type=template&id=60960c3c"
import script from "./GIS.vue?vue&type=script&lang=js"
export * from "./GIS.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__